import * as React from 'react';
import { GridHeaderFilterCellProps } from '@mui/x-data-grid-pro/components/headerFiltering/GridHeaderFilterCell';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { FilterContext } from '../DataGrid';
import './MultiSelect.scss';

export const BooleanSelectFilter = ({ item }: GridHeaderFilterCellProps) => {
  const { values, onChange, disabledFields } = React.useContext(FilterContext);
  const isDisabled = disabledFields?.has(item.field) ?? false;
  const raw = values[item.field];
  const selectValue = raw === true ? 'true' : raw === false ? 'false' : '';

  const handleChange = (event: SelectChangeEvent<string>) => {
    const v = event.target.value;
    const boolValue = v === 'true' ? true : v === 'false' ? false : undefined;
    onChange(item.field, boolValue);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(item.field, undefined);
  };

  return (
    <div className={`filter-row${isDisabled ? ' filter-row--disabled' : ''}`}>
      <div className="multiselect-wrapper">
        <Select value={selectValue} onChange={handleChange} displayEmpty disabled={isDisabled}>
          <MenuItem value=''>All</MenuItem>
          <MenuItem value='true'>Yes</MenuItem>
          <MenuItem value='false'>No</MenuItem>
        </Select>
      </div>
      {selectValue !== '' && (
        <IconButton size="small" onClick={handleClear} className="filter-clear-btn" tabIndex={-1}>
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

export default BooleanSelectFilter;
